import styles from './Trends.module.css'
import { useGlobalContext } from '../../lib/context';
import { Iposts, Isubcatdata } from '../../interfaces';
import { NavLink } from '../ui';
import Image from 'next/image';
import { cmsLoader } from '../../lib/helpers/imageLoader';
import { pushRoute } from '@/lib/helpers/common';

type props = {
    posts: Iposts
    subcategories: Isubcatdata
    categorySlug: string
}
export function TrendsProductTiles({ posts, categorySlug, subcategories }: props) {
    const { props: { countryCode } } = useGlobalContext()
    const siteURL = process.env.SITE_URL + "/" + countryCode;
    return (
    <div className={`${styles.inLivingTiles} trend-${posts.post_id}`}>
        <figure className="mb12" onClick={() => pushRoute(`${siteURL}/trends/${posts.post_slug}`)}>
            <Image
            className="img-responsive"
            src={posts.post_relative}
            height={109}
            width={208}
            loader={cmsLoader}
            alt={posts.post_title}
            />
        </figure>
        <NavLink href={`${siteURL}/trends/category/${categorySlug}/${subcategories.sub_cat_slug}`} className="link font10 ">{subcategories.sub_cat_name}</NavLink>
        <NavLink href={`${siteURL}/trends/${posts.post_slug}`}> <p className="font16 text222 lineHeight20 mb12 lineClamp3">{posts.post_title}</p></NavLink>
    </div>
    )
}